import React from "react";
import { useRevealGroup } from "../../hooks/useReveal";

/**
 * Builder Network / Trust Strip — sits between Markets and Client Stories
 * on the homepage. A quiet ledger of trust signals: developer partners,
 * legal counsel, and lineage timeline.
 */
const TRUST_LINES = [
  { kpi: "40+", label: "Developer & Builder Partnerships" },
  { kpi: "₹2,400 Cr+", label: "Worth of Inventory Curated" },
  { kpi: "8", label: "Generations of Land Custodianship" },
  { kpi: "12", label: "Premium Markets Across NCR" },
];

const PARTNER_TIERS = [
  "Grade-A Developers",
  "Heritage Property Custodians",
  "Senior Legal Counsel",
  "Banking & Tax Advisors",
  "Architects & Master Builders",
  "Wealth Management Houses",
];

const BuilderTrust = () => {
  const ref = useRevealGroup(".reveal");
  return (
    <section
      ref={ref}
      className="py-24 lg:py-28"
      style={{ backgroundColor: "#FAF6EF" }}
      data-testid="builder-trust"
    >
      <div className="max-w-[1340px] mx-auto px-6 lg:px-12">
        <div className="reveal max-w-[700px] mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="block w-10 h-px" style={{ backgroundColor: "#0A3728" }} />
            <span
              className="font-ui uppercase track-eyebrow"
              style={{ fontSize: 9, color: "#0A3728", letterSpacing: "0.48em" }}
            >
              The Numbardar Network
            </span>
            <span className="block w-10 h-px" style={{ backgroundColor: "#0A3728" }} />
          </div>
          <h2
            className="font-display font-medium leading-[1.05]"
            style={{ fontSize: "clamp(36px, 4.4vw, 52px)", color: "#0A0A0A" }}
          >
            A quiet ledger of{" "}
            <span
              className="font-italic italic font-normal"
              style={{ color: "#0A3728" }}
            >
              trust.
            </span>
          </h2>
          <p
            className="font-body italic text-[15px] mt-5"
            style={{ color: "#3A3A3A" }}
          >
            Our network is built deliberately — every partner earns their place. From master
            builders to senior legal counsel, every transaction passes through professionals
            we trust personally.
          </p>
        </div>

        {/* KPI row */}
        <div
          className="reveal delay-1 mt-16 grid grid-cols-2 lg:grid-cols-4 py-10"
          style={{
            borderTop: "1px solid rgba(10,55,40,0.20)",
            borderBottom: "1px solid rgba(10,55,40,0.20)",
          }}
        >
          {TRUST_LINES.map((t, i) => (
            <div
              key={t.label}
              className="text-center px-6"
              style={
                i !== TRUST_LINES.length - 1
                  ? { borderRight: "1px solid rgba(10,55,40,0.12)" }
                  : {}
              }
            >
              <div
                className="num-editorial"
                style={{ fontSize: "clamp(36px, 3.6vw, 50px)", color: "#0A0A0A" }}
              >
                {t.kpi}
              </div>
              <div
                className="font-ui mt-3"
                style={{ fontSize: 9, letterSpacing: "0.36em", color: "#8C7E6A", textTransform: "uppercase" }}
              >
                {t.label}
              </div>
            </div>
          ))}
        </div>

        {/* Partner tiers */}
        <div className="reveal delay-2 mt-14 flex flex-wrap items-center justify-center gap-x-12 gap-y-5">
          {PARTNER_TIERS.map((t) => (
            <span
              key={t}
              className="font-ui uppercase whitespace-nowrap"
              style={{
                fontSize: 10,
                letterSpacing: "0.36em",
                color: "#8C7E6A",
              }}
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuilderTrust;
